module.exports = __webpack_public_path__ + "static/img/no-video.f64769e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/no-video.png
// module id = 4soe
// module chunks = 1